import React from "react";
import PageWithText from "../../components/page-with-text/page-with-text.component";

const LoadingPage = () => {
	return <PageWithText>Loading</PageWithText>;
};

export default LoadingPage;
